module.exports = __webpack_public_path__ + "img/14.31bdc5fa.png";